
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorActionPointer as ObiCursorActionPointerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-action-pointer.js';
 
 
 

 
 export const ObiCursorActionPointer = createComponent({
   react: React,
   tagName: 'obi-cursor-action-pointer',
   elementClass: ObiCursorActionPointerElement,
   events: {
     
   }
  });
 
 